import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between pt-3" }
const _hoisted_3 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Service Details ")
const _hoisted_5 = { class: "flex flex-row space-x-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_7 = { class: "w-full flex flex-col space-y-3" }
const _hoisted_8 = { class: "w-full flex flex-row items-start justify-start" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Bookings")
const _hoisted_10 = { class: "w-full flex flex-col rounded-md border-[1px] border-grey300 px-4 py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_icon = _resolveComponent("roof-icon")!
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_page_data = _resolveComponent("roof-page-data")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "w-[38px] h-[38px] cursor-pointer rounded-full border-[1px] border-gray-grey300 flex flex-row items-center justify-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Logic.Common.goBack()))
        }, [
          _createVNode(_component_roof_icon, {
            customClass: 'h-[20px]',
            name: 'chevron-left'
          })
        ]),
        _createVNode(_component_roof_header_text, { "custom-class": '!text-2xl' }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_roof_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editService(_ctx.EachService)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_roof_page_data, { data: _ctx.pageData }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Booking.BookingTableStructure,
          paginatedData: _ctx.PageBookings,
          "table-date-source": _ctx.Logic.Booking.BookingSource,
          extraQuery: _ctx.extraQuery,
          queryOptionsToHide: [3],
          "sub-page-route": '/bookings/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source", "extraQuery"])
      ])
    ])
  ]))
}